import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'no-access',
  template: '<div class="welcome-strip"><h2>You are not authorised to use this product.</h2></div>'
})
export class NoAccessComponent {
  static route = 'noaccess';
}
